import { CSSProperties } from 'react'
import { StylesConfig } from 'react-select'
import styled, { StyledProps } from 'styled-components'
import { defaultTheme } from '../../../theme'
import { IconCross } from '../../iconography'

/* eslint-disable @typescript-eslint/no-explicit-any */
export type StyleFnArgs = [any, any]
type styleFn = (...args: StyleFnArgs) => CSSProperties

type StyledDropdownProps = StyledProps<{ menuIsOpen: boolean }>
export const DropdownIndicatorStyled = styled.div<StyledDropdownProps>`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  margin-right: 15px;
  cursor: pointer;

  ${(props: StyledDropdownProps) => ({
    [props.menuIsOpen ? 'borderBottom' : 'borderTop']: '5px solid black;',
  })}
`

export const ClearIndicatorStyled = styled(IconCross)`
  margin: 0 8px;
  cursor: pointer;
  fill: ${props => props.theme.color.onPrimaryDark};
  width: 10px;
  height: 10px;
`

export type CustomSelectStyles = StylesConfig<any, any, any>

/**
 * @deprecated use `components` or `variant` instead
 */

export const smallSelectStyles = (invalid: boolean): CustomSelectStyles => ({
  control: (...args: StyleFnArgs) => ({
    ...controlStyle(...args),
    minHeight: '32px',
    borderColor: invalid ? defaultTheme.color.accentDestructive : defaultTheme.color.onSurfaceLowEmphasys,
  }),
  menuList: base => ({
    ...base,
    ...menuListStyle,
  }),
  option: base => ({
    ...base,
    ...optionStyle,
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  }),
})

/**
 * @deprecated use `components` or `variant` instead
 */
export const controlStyle: styleFn = (base, props) => ({
  ...base,
  backgroundColor: props.isDisabled ? defaultTheme.color.backgroundBase : defaultTheme.color.onPrimaryLight,
  cursor: props.isDisabled ? 'not-allowed' : 'pointer',
  borderColor: defaultTheme.color.onSurfaceLowEmphasys,
  opacity: props.isDisabled ? 0.8 : 1,
  minHeight: '40px',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '14px',
  borderRadius: '4px',
  boxShadow: 'none',
  '@media (max-width: 767px)': {
    fontSize: '16px',
  },
})

/**
 * @deprecated use `components` or `variant` instead
 */
export const optionStyle = {
  minHeight: '40px',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  borderRadius: '4px',
  borderColor: defaultTheme.color.onSurfaceLowEmphasys,
  boxSizing: 'border-box' as const,
  marginTop: '4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
}

/**
 * @deprecated use `components` or `variant` instead
 */
export const menuListStyle = {
  padding: '0 4px 4px 4px',
  maxHeight: '50vh',
  minWidth: '100%',
}

/**
 * @deprecated use `components` or `variant` instead
 */
export const menuStyle = {
  minWidth: '100%',
  width: '100%',
}

/**
 * @deprecated use `components` or `variant` instead
 */
export const baseCustomStyles = (invalid: boolean): CustomSelectStyles => ({
  container: base => ({
    ...base,
    width: '100%',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  control: (...args: StyleFnArgs) => {
    return {
      ...controlStyle(...args),
      borderColor: invalid ? defaultTheme.color.accentDestructive : defaultTheme.color.onSurfaceLowEmphasys,
    }
  },
  valueContainer: base => ({
    ...base,
    gap: '4px',
    padding: '4px 0 4px 8px',
  }),
  input: base => ({
    ...base,
    padding: 0,
  }),
})
